import { useState, useRef } from 'preact/hooks';
import WidgetConfigContext from './WidgetConfigContext';


const WidgetConfigProvider = ({ children, config }) => {
  const [configState, setConfigState] = useState(config);
  const initialMaxDaysSearchRef = useRef(config.maxDaysSearch);

  const updateMaxDaysSearch = (newMaxDaysSearch) => {
    const maxDaysSearchValue = newMaxDaysSearch || initialMaxDaysSearchRef.current;
    setConfigState(prevConfig => ({
      ...prevConfig,
      maxDaysSearch: maxDaysSearchValue
    }));
  };

  const contextValue = {
    ...configState,
    initialMaxDaysSearch: initialMaxDaysSearchRef.current,
    updateMaxDaysSearch
  };

  return <WidgetConfigContext.Provider value={contextValue}>{children}</WidgetConfigContext.Provider>;
};

export default WidgetConfigProvider;
